import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';

import PrismViewSwitcherButton from './view-switcher/button.gts';

interface PrismViewSwitcherSignature {
  Args: {
    activeButtonId: string;
    onSetActiveButtonId: (buttonId: string) => void;
  };
  Blocks: {
    default: [
      {
        button: WithBoundArgs<
          typeof PrismViewSwitcherButton,
          'activeButtonId' | 'onSetActiveButtonId'
        >;
      },
    ];
  };
}

const PrismViewSwitcher = <template>
  <div class="prism-view-switcher">
    <ul class="prism-view-switcher-list">
      {{yield
        (hash
          button=(component
            PrismViewSwitcherButton
            activeButtonId=@activeButtonId
            onSetActiveButtonId=@onSetActiveButtonId
          )
        )
      }}
    </ul>
  </div>
</template> satisfies TOC<PrismViewSwitcherSignature>;

export default PrismViewSwitcher;
